import React from 'react';
import blog1 from '../../../images/web-tools.jpg';
import blog2 from '../../../images/prepare.jpg';
import blog3 from '../../../images/HTML-Tag.jpg'

const HomeBlogs = () => {
    const styles = {
        width: "18rem"
    }
    
    return (
        <div className="mt-5">
            <h3 className="textColor text-center"><span className="fs-2 border-bottom border-info">Some of  My Articles </span></h3>
            <div className=" row text-center mt-5 justify-content-evenly text-white">
                <div className="card mt-2 col-md-4 col-sm-12" style={styles}>
                    <img src={blog1} className="card-img-top blogPhoto" alt="blogs"/>
                    <div className="card-body">
                        <h5 className="card-title text-dark">Front end developers tools & my experience</h5>
                        <p className="card-text text-dark">To become a front end developer or full-stack developer there are key tools used by all developers. What if these tools don’t</p>
                        <a href="https://ahmedrazon338.medium.com/all-about-know-to-front-end-developers-tools-my-experience-ae968891a3f7" target="_blank" rel="noreferrer" className="btn btn-primary">Read more</a>
                    </div>
                </div>
                <div className="card mt-2 col-md-4 col-sm-12" style={styles}>
                    <img src={blog2} className="card-img-top blogPhoto" alt="blogs"/>
                    <div className="card-body">
                        <h5 className="card-title text-dark">Prepare yourself for interview</h5>
                        <p className="card-text text-dark">Prepare for your next job in a front-end developer position. In this article, I’ll give some tips that would help your interview. (this is part ....</p>
                        <a href="https://ahmedrazon338.medium.com/prepare-for-interview-for-web-developer-76f321f1cae" target="_blank" rel="noreferrer" className="btn btn-primary">Read more</a>
                    </div>
                </div>
                <div className="card mt-2 col-md-4 col-sm-12" style={styles}>
                    <img src={blog3} className="card-img-top blogPhoto" alt="blogs"/>
                    <div className="card-body">
                        <h5 className="card-title text-dark">Most important HTML tags list</h5>
                        <p className="card-text text-dark">Do you know how many HTML tags exist? Maybe or not. Whatever, if you are a web developer, you don’t have to know all these.....</p>
                        <a href="https://ahmedrazon338.medium.com/most-important-html-tags-listed-down-by-a-web-developer-3156c66cc21a" target="_blank" rel="noreferrer" className="btn btn-primary">Read more</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeBlogs;